import React from 'react';
import {
  Message, Stack, useNotifications,
} from '@doveit/bricks';
import { AssignmentWizardStepProps } from '../types';
import {
  assignmentWizardPlanimetryDelegationFormModelToIdentityDocument, toAssignmentWizardData, assignmentWizardDataToAssignmentWizardPlanimetryDelegationFormModel,
} from './mappers';
import AssignmentWizardPlanimetryDelegationForm, { AssignmentWizardPlanimetryDelegationFormModel } from './AssignmentWizardPlanimetryDelegationForm';
import { getContact, updateContact } from '../../../../../providers/api/contact/contactProvider';
import { Contact } from '../../../../../providers/api/dtos';

export const NO_CONTACTS_INFO_MESSAGE = 'Devi inserire almeno un venditore (step venditore) per attivare la delega.';

const AssignmentWizardPlanimetryDelegation: React.FC<AssignmentWizardStepProps> = ({
  initialData,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const { addError } = useNotifications();
  const [contacts, setContacts] = React.useState<Contact[]>([]);

  React.useEffect(() => {
    async function getContacts() {
      try {
        const dbContacts = await Promise.all((initialData.contacts || []).map((c) => getContact(c.id!)));

        setContacts(dbContacts);
      } catch (error) {
        addError('Errore nel caricamento dei contatti.');
      }
    }
    getContacts();
  }, [addError, initialData.contacts]);

  const onInternalSubmit = React.useCallback(async (formValues: AssignmentWizardPlanimetryDelegationFormModel) => {
    const delegatedContact = contacts.find(({ id }) => formValues.contactId === id);

    const updatedDelegatedContact = delegatedContact?.id ? await updateContact(delegatedContact.id, {
      ...delegatedContact,
      identityDocument: assignmentWizardPlanimetryDelegationFormModelToIdentityDocument(formValues),
    }) : undefined;

    const values = toAssignmentWizardData(
      initialData,
      formValues.planimetryDelegationRequired,
      updatedDelegatedContact,
    );

    const isFormDirty = (formRef?.current as any)?.dirty ?? false;

    onSubmit(values, isFormDirty);
  }, [contacts, formRef, initialData, onSubmit]);

  return (
    <Stack gap={200}>
      {!initialData.contacts?.length && (
        <Message
          type="info"
          message={NO_CONTACTS_INFO_MESSAGE}
        />
      )}
      <AssignmentWizardPlanimetryDelegationForm
        initialValues={assignmentWizardDataToAssignmentWizardPlanimetryDelegationFormModel(initialData, contacts)}
        formRef={formRef}
        onSubmit={onInternalSubmit}
        loading={loading}
        contacts={contacts}
      />
    </Stack>
  );
};

export default AssignmentWizardPlanimetryDelegation;
